import Button from "@/components/Common/Button";
import useManageCredits from "@/hooks/useManageCredits";
import {useSettingsDirty} from "@/hooks/useSettingsNavigation";
import ManageCreditsContent from "@/pages/plans/creditSystem/ManageCreditsContent";
import {useSettingsAgencyStore} from "@/store/agency";
import {useSettingsCompanyStore} from "@/store/company";
import type {TSettingsScope} from "@/store/types";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const ManageCreditsSubview: FC<{mode: "add" | "remove"; onClose(): void; scope: TSettingsScope}> = ({
  mode,
  onClose,
  scope,
}) => {
  const {t} = useTranslation("common");
  const scopeAgency = useSettingsAgencyStore(state => state.agency);
  const company = useSettingsCompanyStore(state => state.company);

  const isAgencyScope = scope.type === "agency";
  const agency = isAgencyScope ? scopeAgency : company.agency;
  const credits = agency?.credits ?? 0;
  const influencerFees = {
    pro: agency?.pro_service_fee_percentage,
    regular: agency?.cash_reward_service_fee_percentage,
  };

  const manageCredits = useManageCredits({
    agencyId: agency?.id,
    companyId: isAgencyScope ? undefined : company.id,
    credits,
    influencerFees,
    onSuccess: onClose,
    type: mode,
  });
  useSettingsDirty(!!manageCredits.inputValue);

  return (
    <div className="flex flex-col gap-8">
      <ManageCreditsContent credits={credits} influencerFees={influencerFees} manageCredits={manageCredits} />
      <div className="flex gap-3">
        <Button
          buttonStyle="White"
          className="h-10 flex-1 px-5 text-sm sm:flex-none"
          isDisabled={manageCredits.isPending}
          onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button
          buttonStyle="Gradient"
          className="h-10 flex-1 px-5 text-sm sm:flex-none"
          isDisabled={manageCredits.isConfirmDisabled}
          isLoading={manageCredits.isPending}
          onClick={manageCredits.confirm}>
          {mode === "add" ? t("add_credits") : t("delete_credits")}
        </Button>
      </div>
    </div>
  );
};

export default ManageCreditsSubview;
